import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-exit-fullscreen",
  "use": "icon-icon-exit-fullscreen-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-exit-fullscreen\"><path d=\"M46.08 404.48V46.08h358.4M276.096 174.784L428.16 326.848 326.784 428.16 174.72 276.16zM404.48 976H46.08v-358.4M175.104 745.6L327.04 593.6l101.376 101.312-152.064 152.064zM620.16 46.08h358.4v358.4M850.56 276.096L698.368 428.16 597.12 326.784l152.064-152.064zM977.92 618.24v358.4h-358.4M748.096 849.664L596.032 697.6l101.376-101.312 152.064 152z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-exit-fullscreen.svg
// module id = Z81N
// module chunks = 3